angular.module("ainapp")
    .controller("payrecVoucherTrashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Payment & Receipt Voucher Trash";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {


                            if ($scope.selectedVoucher.NameVal == "Company Expense") {
                                MainService.DeletedCompanyExpenses(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Journal Voucher") {
                                MainService.DeletedJournalVouchers(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Opening Balance") {
                                MainService.DeletedOpeningBalances(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Cash Payment") {
                                MainService.DeletedCpvs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Cash Receipt") {
                                MainService.DeletedCrvs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Fund Payment") {
                                MainService.DeletedFpvs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Fund Receipt") {
                                MainService.DeletedFrvs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Cheque Payment") {
                                MainService.DeletedChequePVs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Cheque Receipt") {
                                MainService.DeletedChequeRvs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Credit Note") {
                                MainService.DeletedCreditNotes(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Debit Note") {
                                MainService.DeletedDebitNotes(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else {
                                o.success({
                                    Data: [],
                                    Total: 0
                                });
                            }


                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                UpdatedDate: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "UpdatedBy.UserName": {
                                    type: "string",
                                },
                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "VoucherNumber",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },
                        {
                            field: "CreatedBy.UserName",
                            title: "Created By",
                            width: "100px"
                    },
                        {
                            field: "CreatedDate",
                            template: "<p> {{dataItem.CreatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Created Date",
                            width: "100px"
                    },
                        {
                            field: "UpdatedBy.UserName",
                            title: "Updated By",
                            width: "100px"
                    },
                        {
                            field: "UpdatedDate",
                            template: "<p> {{dataItem.UpdatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Updated Date",
                            width: "100px"
                    },

                  ],
                };


            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VArray = [];

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    var temp41 = {
                        Id: 41,
                        Name: "Company Expense",
                        NameVal: "Company Expense"
                    };
                    if ($scope.CompanyProfile.CompanyExpense != "" & $scope.CompanyProfile.CompanyExpense != null) {
                        temp41.Name = $scope.CompanyProfile.CompanyExpense;
                    }
                    $scope.VArray.push(temp41);

                    var temp42 = {
                        Id: 42,
                        Name: "Journal Voucher",
                        NameVal: "Journal Voucher"
                    };
                    if ($scope.CompanyProfile.JournalVoucher != "" & $scope.CompanyProfile.JournalVoucher != null) {
                        temp42.Name = $scope.CompanyProfile.JournalVoucher;
                    }
                    $scope.VArray.push(temp42);

                    var temp43 = {
                        Id: 43,
                        Name: "Opening Balance",
                        NameVal: "Opening Balance"
                    };
                    if ($scope.CompanyProfile.OpeningBalance != "" & $scope.CompanyProfile.OpeningBalance != null) {
                        temp43.Name = $scope.CompanyProfile.OpeningBalance;
                    }
                    $scope.VArray.push(temp43);

                    var temp44 = {
                        Id: 44,
                        Name: "Cash Payment",
                        NameVal: "Cash Payment"
                    };
                    if ($scope.CompanyProfile.CashPayment != "" & $scope.CompanyProfile.CashPayment != null) {
                        temp44.Name = $scope.CompanyProfile.CashPayment;
                    }
                    $scope.VArray.push(temp44);

                    var temp45 = {
                        Id: 45,
                        Name: "Cash Receipt",
                        NameVal: "Cash Receipt"
                    };
                    if ($scope.CompanyProfile.CashReceipt != "" & $scope.CompanyProfile.CashReceipt != null) {
                        temp45.Name = $scope.CompanyProfile.CashReceipt;
                    }
                    $scope.VArray.push(temp45);

                    var temp46 = {
                        Id: 46,
                        Name: "Fund Payment",
                        NameVal: "Fund Payment"
                    };
                    if ($scope.CompanyProfile.FundPayment != "" & $scope.CompanyProfile.FundPayment != null) {
                        temp46.Name = $scope.CompanyProfile.FundPayment;
                    }
                    $scope.VArray.push(temp46);

                    var temp47 = {
                        Id: 47,
                        Name: "Fund Receipt",
                        NameVal: "Fund Receipt"
                    };
                    if ($scope.CompanyProfile.FundReceipt != "" & $scope.CompanyProfile.FundReceipt != null) {
                        temp47.Name = $scope.CompanyProfile.FundReceipt;
                    }
                    $scope.VArray.push(temp47);

                    var temp48 = {
                        Id: 48,
                        Name: "Cheque Payment",
                        NameVal: "Cheque Payment"
                    };
                    if ($scope.CompanyProfile.ChequePayment != "" & $scope.CompanyProfile.ChequePayment != null) {
                        temp48.Name = $scope.CompanyProfile.ChequePayment;
                    }
                    $scope.VArray.push(temp48);

                    var temp49 = {
                        Id: 49,
                        Name: "Cheque Receipt",
                        NameVal: "Cheque Receipt"
                    };
                    if ($scope.CompanyProfile.ChequeReceipt != "" & $scope.CompanyProfile.ChequeReceipt != null) {
                        temp49.Name = $scope.CompanyProfile.ChequeReceipt;
                    }
                    $scope.VArray.push(temp49);

                    var temp56 = {
                        Id: 56,
                        Name: "Credit Note",
                        NameVal: "Credit Note"
                    };
                    if ($scope.CompanyProfile.CreditNote != "" & $scope.CompanyProfile.CreditNote != null) {
                        temp56.Name = $scope.CompanyProfile.CreditNote;
                    }
                    $scope.VArray.push(temp56);

                    var temp57 = {
                        Id: 57,
                        Name: "Debit Note",
                        NameVal: "Debit Note"
                    };
                    if ($scope.CompanyProfile.DebitNote != "" & $scope.CompanyProfile.DebitNote != null) {
                        temp57.Name = $scope.CompanyProfile.DebitNote;
                    }
                    $scope.VArray.push(temp57);

                    $scope.selectedVoucher = $scope.VArray[0];
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");

                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.refresh = function () {
                $scope.selectedVoucher = $scope.VArray[0];
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.changeView = function (data) {
                $scope.selectedVoucher = data;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


                }])
